export enum MenuDirection {
  right = 0,
  left = 1
}
